/* unplugin-vue-components disabled */import { render } from "./CollectionItemTypePopup.vue?vue&type=template&id=33de71ae&scoped=true&ts=true"
import script from "./CollectionItemTypePopup.vue?vue&type=script&lang=ts"
export * from "./CollectionItemTypePopup.vue?vue&type=script&lang=ts"

import "./CollectionItemTypePopup.vue?vue&type=style&index=0&id=33de71ae&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33de71ae"]])

export default __exports__